import { PButton } from '@porsche-design-system/components-react'
import React from 'react'
import { useFormContext } from 'react-hook-form'

import { PortalContext } from '../../../utils/PortalContext'

import styles from './drawerfooter.module.css'

type Props = {
  onClick: (event: React.MouseEvent) => void
}

const DrawerFooter = ({ onClick }: Props) => {
  const { loading } = React.useContext(PortalContext)
  const { formState } = useFormContext()

  const disableButton = !formState.isDirty || !formState.isValid

  return (
    <footer className={styles.actions}>
      <PButton variant='primary' className={styles.save} loading={loading} disabled={disableButton}>
        Speichern
      </PButton>
      <PButton variant='tertiary' icon='close' onClick={onClick}>
        Abbrechen
      </PButton>
    </footer>
  )
}

export default DrawerFooter
